<template>
  <div class="page-wrapper member-wrap">
    <div class="container-fluid">
      <breadcrumb :items="breadcrumbItems" />
      <div class="">
        <div class="claim-wrap">
          <div class="claim-contents">
            <div class="claim-title">
              <h1>Claim List </h1>
              
              <button class="clear-search" @click="clearData">Clear Search</button>
            </div>
            <claim-filter :filters="filterQuery" @onSearch="filterData"  />
            <div class="claim-btn-wrap">               
                <button class=" upload-file-btn" @click="openForm">
                  <i class="fas fa-upload"></i
                  ><span style="margin-left: 10px;" class="ml-2"
                    >Upload claim file(s)</span
                  >
                </button>
              </div>
            <div class="claim-list-tbl mt-3 table-responsive">
            <div class="top-pagination">
            <pagination :rows.sync="claimList" :filters="filterQuery" />
          </div>
         
            <claim-list-table
              :claimList="claimList"
              :formatDate="formatDate"
              :statusClass="statusClass"
              @view-file="viewFile"
              @submit-file="openSubmitModal"
            />
            <pagination :rows.sync="claimList" :filters="filterQuery" />
            </div>
            <file-submit-modal
              v-if="selectedFiles"
              :files="selectedFiles"
              :claimData="claimData"
              @close="selectedFiles = null"
            />
            <file-upload-modal
              :isEdit="isEdit"
              :row="selectedClaim"
              @close="selectedClaim = null"
              @update-isEdit="isEdit = $event"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Helper from "@/resource/Helper";
import ClaimListTable from "./ClaimListTable.vue";
import FileUploadModal from "./ClaimUploadModal.vue";
import FileSubmitModal from "./ClaimSubmitModal.vue";
import ClaimFilter from "./ClaimFilter.vue";

const filterData = {
  first_name: "",
  last_name: "",
  member_email:"",
  plan_name: "",
  created_date:"",
  submitted_date:""
};
export default {
  components: {
    FileUploadModal,
    ClaimListTable,
    FileSubmitModal,
    ClaimFilter,
  },
  data() {
    return {
      filterQuery: { ...filterData },
      files: [],
      claimList: [],
      claimData: [],
      selectedClaim: null,
      selectedFiles: null,
      isEdit: false,
      clear: false,
      pagination: {
        page: 1,
      },
      breadcrumbItems: [{ title: "Prudential Claim", active: true }],
    };
  },
  methods: {   
    clearData() {
      this.filterQuery = { ...filterData };
      this.clear = !this.clear;
      this.getData(this.filterQuery);
    },
    filterData(filters) {
      this.filterQuery = filters;
      this.getData(this.filterQuery);
    },
    async getData(filters = []) {
      let url;
      if (filters) {
        let filterUrl = Helper.objToUrlParams(filters);
        url = 'v2/prudential-claim/all-prudential-list' + `?${filterUrl}`;
      } else {
        url = 'v2/prudential-claim/all-prudential-list'
      }

      let loader = this.$loading.show();
      await axios
        .get(url)
        .then((res) => {
          this.claimList = res.data;
        })
        .finally(() => {
          loader.hide();
        });
    },
    viewFile(claim) {
      this.isEdit = true;
      this.selectedClaim = claim;
      this.$bvModal.show("uploadFileModal");
    },
    statusClass(status) {
      switch (status?.toLowerCase()) {
        case "sent":
          return "#003964";
        case "queued":
          return "orange";
        case "blacklisted":
          return "#000";
        case "invalid":
          return "red";
        case "delivered":
          return "#05ac05";
        case "opened":
          return "#037003";
        case "bounced":
          return "#ed1c24";
        case "blocked":
          return "#003964";
        case "unsubscribed":
          return "#ff2400";
        default:
          return "black";
      }
    },
    formatDate(date) {
      if (date) {
        const formattedDate = new Date(date);
        return formattedDate.toLocaleDateString("en-US", {
          year: "numeric",
          month: "long",
          day: "numeric",
        });
      }
      return "";
    },
    openForm() {
      this.selectedClaim = {};
      this.$bvModal.show("uploadFileModal");
    },
    openSubmitModal(claim) {
      this.claimData = claim;
      this.selectedFiles = claim.files;
      this.$bvModal.show("submitFile");
    },
    
  },
 
  created() {
    this.getData();
  },
};
</script>
<style src="@/assets/css/viewclients.css"></style>
<style>
@import "../../assets/css/claim-list.css";

input[type="file"] {
  display: none;
}

.choose-file-btn {
  display: inline-block;
  padding: 24px 24px;
  background-color: #f1f0ef;
  color: rgb(39, 39, 39);
  border: none;
  cursor: pointer;
  border-radius: 4px;
  width: 100%;
  margin-bottom: 12px;
}

.choose-file-btn:focus {
  outline: none;
}
.action-bg {
  cursor: pointer;
  margin-left: 5px;
}
.rep-body-content-wrap {
  padding: 32px;
  background-color: #f3f6f8;
  margin-left: 200px;
  max-width: calc(100% - 200px);
  transition: all ease-in-out 0.3s;
}
.claim-list-tbl tbody tr td:last-child {
  /* border-right: 1px solid #0000001a; */
  height: 100%;
  border: none;
}
.claim-list-tbl tbody tr {
  border-right: 1px solid #0000001a;
}
</style>

<style scoped>
.claim-btn-wrap{
  margin-top: 50px;
  display: flex;
  justify-content: end;
 
}
</style>